"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bootstrap = bootstrap;
exports.mount = mount;
exports.unmount = unmount;
require("regenerator-runtime/runtime");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("/root/workspace/mall_vue_JOYE/node_modules/core-js/modules/es6.array.iterator.js");
require("/root/workspace/mall_vue_JOYE/node_modules/core-js/modules/es6.promise.js");
require("/root/workspace/mall_vue_JOYE/node_modules/core-js/modules/es6.object.assign.js");
require("/root/workspace/mall_vue_JOYE/node_modules/core-js/modules/es7.promise.finally.js");
var _vue = _interopRequireDefault(require("vue"));
require("normalize.css/normalize.css");
var _elementUi = _interopRequireDefault(require("element-ui"));
require("element-ui/lib/theme-chalk/index.css");
require("babel-polyfill");
require("@/assets/zdy_page_icon/iconfont.css");
var _App = _interopRequireDefault(require("./App"));
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _btnPermissions = _interopRequireDefault(require("./utils/btnPermissions.js"));
var _aweDnd = _interopRequireDefault(require("awe-dnd"));
var _component = _interopRequireDefault(require("./views/zdy_dragging/component"));
var _lang = _interopRequireDefault(require("./lang"));
require("./icons");
require("./permission");
var filters = _interopRequireWildcard(require("./filters"));
require("./plugins/element.js");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } // A modern alternative to CSS resets
_elementUi.default.Dialog.props.closeOnClickModal.default = false;
// import './element-variables.scss'

var sidebarType = 1;
if (sidebarType === 1) {
  Promise.resolve().then(function () {
    return _interopRequireWildcard(require("./styles/indexA.scss"));
  });
} else {
  Promise.resolve().then(function () {
    return _interopRequireWildcard(require("./styles/index.scss"));
  });
}

// 国际化
// Internationalization
// icon
// permission control
// global filters

// register global utility filters.
Object.keys(filters).forEach(function (key) {
  _vue.default.filter(key, filters[key]);
});
_vue.default.use(_aweDnd.default); //引入可拖拽插件
(0, _component.default)(); // 全局注册自定义页面装修组件
_vue.default.use(_elementUi.default, {
  // locale,
  i18n: function i18n(key, value) {
    return _lang.default.t(key, value);
  }
});
_vue.default.config.productionTip = false;
_vue.default.prototype.sidebarType = sidebarType; //挂载到Vue实例上面
// 子应用的入口文件
function bootstrap() {
  return _bootstrap.apply(this, arguments);
}
function _bootstrap() {
  _bootstrap = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          console.log('mall app bootstraped');
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _bootstrap.apply(this, arguments);
}
function mount(_x) {
  return _mount.apply(this, arguments);
}
function _mount() {
  _mount = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(props) {
    return regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          console.log('mall app mount', props);
          // 这里应该渲染子应用，例如：
          // ReactDOM.render(<App />, props.container.querySelector('#root'));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _mount.apply(this, arguments);
}
function unmount(_x2) {
  return _unmount.apply(this, arguments);
}
function _unmount() {
  _unmount = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(props) {
    return regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          console.log('mall app unmount');
          // 这里应该清理子应用，例如：
          // ReactDOM.unmountComponentAtNode(props.container.querySelector('#root'));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _unmount.apply(this, arguments);
}
new _vue.default({
  el: '#app',
  router: _router.default,
  store: _store.default,
  i18n: _lang.default,
  render: function render(h) {
    return h(_App.default);
  }
});